import React, { Component } from 'react';

import Sticky from 'react-sticky-el';

import { StickyPanelAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { DocumentContext } from '@philips-emr/tws-core/lib/component/context';
import { arrayOf, bool, element, number, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';

import { Panel } from '..';

import './sticky-panel.scss';

@AwesomeComponent({ type: ComponentType.LAYOUT, api: StickyPanelAPI })
class StickyPanel extends Component {

  static contextType = DocumentContext;

  static propTypes = {
    bottom: bool,
    children: oneOfType([element, arrayOf(element)]),
    gridArea: string.notEnumerable(),
    height: number,
    offset: number,
    uuid: string,
  };

  static defaultProps = {
    bottom: false,
    offset: 0,
  };

  render() {
    const { scrollElement } = this.context;
    
    if (!scrollElement) {
      return null;
    }

    const { children, gridArea, height, bottom, offset, uuid } = this.props;

    const invertedOffset = offset * -1;

    const classOffSet = {
      '--offsetTop': `${bottom ? invertedOffset : offset}px`,
    };

    const mode = bottom ? 'bottom' : 'top';

    return (
      <Panel className="c-sticky-panel" uuid={uuid} gridArea={gridArea} height={height} >
        <Sticky
          className="c-sticky-panel__wrapper"
          mode={mode}
          scrollElement={scrollElement}
          stickyClassName="is-sticky"
          style={classOffSet}
          topOffset={invertedOffset}
        >
          {children}
        </Sticky>
      </Panel>
    );
  }
}

export default StickyPanel;
